import { GO_SEARCH, SEO_BREADCRUMB_FORUM_SEARCH, SEO_TITLE_FORUM_SEARCH } from 'mk/autogenerated/translations/ForumSearchPage.76c4f755c88abb527fde367808b9cb6e'
import ForumSearch from 'mk2/apps/forum/containers/ForumSearch/ForumSearch';
import {
    forumSearch,
    forumSearchSave,
    forumSearchUpdate,
} from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.actions';
import forumSearchReducer from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.reducers';
import forumSearchSaga from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.sagas';
import { getForumSearchQuery } from 'mk2/apps/forum/containers/ForumSearch/ForumSearch.selectors';
import { breadcrumbsSubforum } from 'mk2/apps/forum/structuredData';
import { forumSearchUrl, forumUrl } from 'mk2/apps/forum/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import { cacheLast } from 'mk2/helpers/cache';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import { AppState, getRequestBaseUrl } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
    className?: string;
}

interface StateProps {
    queryFromState: string;
    queryFromUrl: string;
    baseUrl: string;
}

interface DispatchProps {
    onSearch(query: string);
    onSearchSave(query: string);
    onSearchUpdate(query: string);
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ForumSearchPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onSearchCache = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const queryFromState = getForumSearchQuery(state);
            const queryFromUrl = parse(ownProps.location.search.replace(/^\?/, '')).q || '';

            return {
                queryFromState,
                queryFromUrl,
                baseUrl: getRequestBaseUrl(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onSearchUpdate: forumSearchUpdate,
            onSearch: forumSearch,
            onSearchSave: forumSearchSave,
        };
    }

    public getMetaTitle(props: Props): string {
        const { queryFromUrl } = props;
        return (queryFromUrl) ? queryFromUrl : SEO_TITLE_FORUM_SEARCH;
    }

    public getStructuredData(props: Props): object[] {
        const { baseUrl } = props;

        return [breadcrumbsSubforum(baseUrl, SEO_BREADCRUMB_FORUM_SEARCH, forumSearchUrl)];
    }

    public render(props: Props): JSX.Element {
        return (
            <ForumSearch {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return forumUrl;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Forum - Branding',
        };
    }

    public getHeaderRight(props: Props): React.ReactNode {
        return (
            <Btn
                type={BtnType.Blue}
                label={GO_SEARCH}
                onClick={this.onSearchCache(() => props.onSearch(props.queryFromState), props.queryFromState, props.onSearch)}
            />
        );
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumSearch', forumSearchReducer);
        store.injectSaga('containers.forum.forumSearch', forumSearchSaga);
    }

}
